import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card bloco-card",class:_vm.classesCss,on:{"click":_vm.ativarCard}},[_c('p',{staticClass:"mb-0 mt-1 font-14",domProps:{"textContent":_vm._s(_vm.card.titulo)}}),(_vm.qtd_produtos === null)?_c(VProgressLinear,{staticClass:"mt-3",attrs:{"color":"red","indeterminate":""}}):_c('p',{staticClass:"mb-0 font-20 font-weight-bold",domProps:{"textContent":_vm._s(_vm.qtd_produtos)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }